module.exports = __webpack_public_path__ + "static/img/nandian2.752bc07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ecDeal/nandian2.png
// module id = 551
// module chunks = 12